import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { Invoice, IInvoice, DocumentDirectionEnum } from "@/models/invoice.entity";
import { MrfiktivInvoiceControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { getModule, Module } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { InvoiceDataAccessLayer } from "./access-layers/invoice.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { InvoicePageDataProvider } from "./page-data-provider/invoice.page-data-provider";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";

@Module({
  dynamic: true,
  namespaced: true,
  name: "invoice-outbound",
  store
})
export class InvoiceOutboundStore extends PaginatedBaseStore<IInvoice, MrfiktivInvoiceControllerGetParamsGen> {
  protected _data = InvoiceDataAccessLayer;
  protected _pageProvider = InvoicePageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = Invoice.filterables;

  hiddenFilter: IPageFilterElement[] = [
    new PageFilterElement({
      key: "direction",
      operation: PageFilterOperationEnum.EQUAL,
      value: DocumentDirectionEnum.OUTBOUND
    })
  ];
}

export const InvoiceOutboundModule = getModule(InvoiceOutboundStore);
